<script setup lang="ts">
const { isNew } = useLayoutVersion()
const { feature } = useCountryConfig()
</script>

<template>
  <template v-if="feature.displayLayoutVersionToggle">
    <v-divider />
    <v-list-item
      :title="isNew ? $t('layout.versionToggle.new') : $t('layout.versionToggle.legacy')"
      data-nav-id="layout_version_toggle"
      @click.prevent="isNew = !isNew"
    >
      <template #append>
        <v-switch
          :model-value="isNew"
          hide-details
          density="compact"
          color="red-600"
          inset
          @click.stop
          @update:model-value="isNew = $event === true"
        />
      </template>
    </v-list-item>
  </template>
</template>
